import { PraState } from '../types'

const initialState: PraState = {
  praData: {},
  isLoading: false,
  isLoadingFailed: false,
  isPopulated: false,
}

export default initialState
